//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";

export default {
  name: "PlanAddedInstagramComponent",
  components: { HiCell },
  methods: {
    /**
     * 点击进入人员遍历页面
     */
    cellClick() {
      this.$router.push({ name: "MyPlanAddInstagramPage" });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/added_instagram/Index.vue